export default {"src":"/_next/static/media/icon-email.8deae55f.svg","height":24,"width":24};